import {createFileRoute, useNavigate} from '@tanstack/react-router'

import {useAuthContext} from 'src/auth/auth-context'
import {ALL_YARDS, resolveBoardYard} from 'src/dispatch/yards'
import {EquipmentExceptionsPage} from 'src/equipment-checks/equipment-exceptions-page'

type ExceptionsSearch = {yard?: string}

export const Route = createFileRoute('/_app/rental-assets/exceptions')({
    validateSearch: (search: Record<string, unknown>): ExceptionsSearch => {
        const yard = search['yard']
        return typeof yard === 'string' ? {yard} : {}
    },
    component: EquipmentExceptionsRoute,
})

function EquipmentExceptionsRoute() {
    const {yard} = Route.useSearch()
    const {user} = useAuthContext()
    const navigate = useNavigate()

    return (
        <EquipmentExceptionsPage
            yardId={resolveBoardYard(yard, user?.dispatchYardId)}
            onYardChange={(yardId) =>
                navigate({
                    to: '/rental-assets/exceptions',
                    search: {yard: yardId ?? ALL_YARDS},
                    replace: true,
                })
            }
        />
    )
}
